/* ============================================================
   PREESA SOAPS — preesa-custom.js  v2
   Horizon Theme (Preesa Dev)
   Updated with correct Horizon class names
   ============================================================ */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     1. HEADER — scroll shadow
  ───────────────────────────────────────── */
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('preesa-scrolled', window.scrollY > 50);
    }, { passive: true });
  }


  /* ─────────────────────────────────────────
     2. SCROLL REVEAL
  ───────────────────────────────────────── */
  const revealEls = document.querySelectorAll('.preesa-reveal');
  if (revealEls.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('preesa-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => revealObserver.observe(el));
  }


  /* ─────────────────────────────────────────
     3. HERO TEXT STAGGER
  ───────────────────────────────────────── */
  function initHeroAnimation() {
    const heroSelectors = [
      '.banner .banner__content > *',
      '.banner .rte > *',
      '[class*="hero"] h1',
      '[class*="hero"] h2',
      '[class*="hero"] p',
      '[class*="hero"] a',
      '[class*="hero"] .button',
    ];
    let index = 0;
    heroSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(22px)';
        el.style.transition = `opacity 0.75s ease ${index * 0.12 + 0.1}s, transform 0.75s ease ${index * 0.12 + 0.1}s`;
        index++;
        requestAnimationFrame(() => {
          setTimeout(() => {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }, 80);
        });
      });
    });
  }
  if (document.readyState === 'complete') {
    initHeroAnimation();
  } else {
    window.addEventListener('load', initHeroAnimation);
  }


  /* ─────────────────────────────────────────
     4. STATS COUNTER
  ───────────────────────────────────────── */
  const counters = document.querySelectorAll('.preesa-counter');
  if (counters.length) {
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseInt(el.getAttribute('data-count'), 10);
        const suffix = el.getAttribute('data-suffix') || '';
        const prefix = el.getAttribute('data-prefix') || '';
        const duration = 1800;
        const startTime = performance.now();
        function tick(now) {
          const progress = Math.min((now - startTime) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = prefix + Math.floor(eased * target) + suffix;
          if (progress < 1) requestAnimationFrame(tick);
          else el.textContent = prefix + target + suffix;
        }
        requestAnimationFrame(tick);
        countObserver.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(el => countObserver.observe(el));
  }


  /* ─────────────────────────────────────────
     5. FLOATING CTA
  ───────────────────────────────────────── */
  const floatingCta = document.getElementById('preesa-floating-cta');
  if (floatingCta) {
    Object.assign(floatingCta.style, {
      opacity: '0',
      transform: 'translateY(16px)',
      transition: 'opacity 0.4s ease, transform 0.4s ease',
      pointerEvents: 'none'
    });
    let ctaVisible = false;
    window.addEventListener('scroll', () => {
      const show = window.scrollY > 400;
      if (show === ctaVisible) return;
      ctaVisible = show;
      floatingCta.style.opacity = show ? '1' : '0';
      floatingCta.style.transform = show ? 'translateY(0)' : 'translateY(16px)';
      floatingCta.style.pointerEvents = show ? 'auto' : 'none';
    }, { passive: true });
  }


  /* ─────────────────────────────────────────
     6. PRODUCT CARD TILT
  ───────────────────────────────────────── */
  const productCards = document.querySelectorAll('.product-grid__card');
  productCards.forEach(card => {
    card.style.transition = 'transform 0.5s ease, box-shadow 0.5s ease';
    card.style.willChange = 'transform';
    card.addEventListener('mouseenter', () => {
      card.style.boxShadow = '0 16px 40px rgba(28, 28, 30, 0.14)';
    });
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const rotateX = ((y - rect.height / 2) / rect.height) * -5;
      const rotateY = ((x - rect.width / 2) / rect.width) * 5;
      card.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-6px)`;
      card.style.transition = 'transform 0.1s ease, box-shadow 0.1s ease';
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'perspective(900px) rotateX(0) rotateY(0) translateY(0)';
      card.style.transition = 'transform 0.5s ease, box-shadow 0.5s ease';
      card.style.boxShadow = '';
    });
  });


  /* ─────────────────────────────────────────
     7. PRODUCT IMAGE ZOOM ON HOVER
  ───────────────────────────────────────── */
  document.querySelectorAll('.card-gallery img').forEach(img => {
    img.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
    img.closest('.card-gallery').style.overflow = 'hidden';
    img.addEventListener('mouseenter', () => { img.style.transform = 'scale(1.07)'; });
    img.addEventListener('mouseleave', () => { img.style.transform = 'scale(1)'; });
  });


  /* ─────────────────────────────────────────
     8. MARQUEE — pause on hover
  ───────────────────────────────────────── */
  const marquee = document.querySelector(
    '.marquee__content, [class*="marquee__list"], [class*="ticker"]'
  );
  if (marquee) {
    marquee.addEventListener('mouseenter', () => { marquee.style.animationPlayState = 'paused'; });
    marquee.addEventListener('mouseleave', () => { marquee.style.animationPlayState = 'running'; });
  }


  /* ─────────────────────────────────────────
     9. SMOOTH ANCHOR SCROLL
  ───────────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const id = this.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const offset = header ? header.offsetHeight + 16 : 96;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth'
      });
    });
  });


  /* ─────────────────────────────────────────
     10. SUBTLE PARALLAX
  ───────────────────────────────────────── */
  const parallaxEls = document.querySelectorAll('.preesa-parallax');
  if (parallaxEls.length && window.matchMedia('(min-width: 768px)').matches) {
    window.addEventListener('scroll', () => {
      parallaxEls.forEach(el => {
        const speed = parseFloat(el.getAttribute('data-speed')) || 0.2;
        const rect = el.getBoundingClientRect();
        const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed * -1;
        el.style.transform = `translateY(${offset}px)`;
      });
    }, { passive: true });
  }


  /* ─── AUTO SCROLL REVEAL ─── */
  (function () {
    const skipKeywords = ['hero', 'header', 'announcement', 'footer'];
    document.querySelectorAll('[id^="shopify-section-template"]').forEach((section, index) => {
      const id = section.id.toLowerCase();
      if (skipKeywords.some(k => id.includes(k))) return;
      section.classList.add('preesa-reveal');
      section.style.transitionDelay = `${index * 0.05}s`;
    });
    const newReveals = document.querySelectorAll('.preesa-reveal:not([data-observed])');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('preesa-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    newReveals.forEach(el => {
      el.setAttribute('data-observed', '1');
      observer.observe(el);
    });
  })();


  /* ─── FLOATING PILL HEADER ─── */
  /* FIX: removed el.style.overflow = 'hidden' — it was clipping the cart
     count bubble. border-radius alone achieves the pill shape. */
  (function initPillHeader() {
    const headerInner  = document.querySelector('header-component > header') || document.querySelector('header');
    const headerOuter  = document.querySelector('header-component');
    const headerSticky = document.querySelector('sticky-header');
    const hero = document.querySelector('#MainContent .shopify-section:first-child');
    if (!headerInner || !hero) return;
    window.addEventListener('scroll', () => {
      const progress   = Math.min(window.scrollY / hero.offsetHeight, 1);
      const radius     = (progress * 45).toFixed(1);
      const side       = (progress * 20).toFixed(1);
      const blur       = (progress * 24).toFixed(1);
      const shadowOpac = (progress * 0.12).toFixed(3);
      [headerInner, headerOuter, headerSticky].forEach(el => {
        if (!el) return;
        el.style.borderRadius = `${radius}px`;
        // ── overflow:hidden removed — was clipping cart count bubble ──
      });
      const target = headerSticky || headerOuter || headerInner;
      target.style.marginLeft  = `${side}px`;
      target.style.marginRight = `${side}px`;
      target.style.boxShadow   = progress > 0.02 ? `0 4px ${blur}px rgba(0,0,0,${shadowOpac})` : 'none';
    }, { passive: true });
  })();


  /* ─────────────────────────────────────────
     11. COLLECTION PAGE — Card 3D Tilt + View Product CTA
  ───────────────────────────────────────── */
  (function () {
    const collCards = document.querySelectorAll('.collection .card-wrapper');
    if (!collCards.length) return;
    collCards.forEach(card => {
      const inner = card.querySelector('.card');
      const imgWrap = card.querySelector('.card__inner');
      if (!inner) return;
      if (imgWrap) {
        imgWrap.style.position = 'relative';
        const cta = document.createElement('span');
        cta.className = 'preesa-card-cta';
        cta.textContent = 'View Product →';
        imgWrap.appendChild(cta);
      }
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const cx = rect.width / 2;
        const cy = rect.height / 2;
        const rotX = ((y - cy) / cy) * -5;
        const rotY = ((x - cx) / cx) * 5;
        inner.style.transform = `perspective(900px) rotateX(${rotX}deg) rotateY(${rotY}deg) translateY(-6px)`;
        inner.style.transition = 'transform 0.1s ease';
      });
      card.addEventListener('mouseleave', () => {
        inner.style.transform = '';
        inner.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      });
    });
  })();


/* ─────────────────────────────────────────
   15. FREE LOOFAH GIFT
   Buy 4 soaps → pick any loofah color free.
   Fix 1 — qty locked to 1 (hide + btn + API safety net)
   Fix 2 — picker shows ONCE only (threshold-crossing reset)
   Fix 3 — correct Horizon cart page selectors
         (.cart-items__table-row / .quantity-selector)
───────────────────────────────────────── */
(function () {
  const MIN_SOAPS          = 4;
  const SOAP_HANDLE        = 'soaps';
  const LOOFAH_MAIN_HANDLE = 'preesa-loofah-bath-sponge';
  const LOOFAH_GIFT_HANDLE = 'loofah-free-gift';
  const POLL_MS            = 6000; // FIX: was 2000 — caused 429 rate limit errors

  let soapIds         = [];
  let colorOptions    = [];
  let freeVariantIds  = [];
  let initialized     = false;
  let pickerDismissed = false;
  let isAddingGift    = false;
  let prevSoapCount   = -1;   // -1 = not yet polled
  let selectedVariant = null;

  // ── DATA FETCHING ─────────────────────────────────

  function fetchSoapIds() {
    return fetch('/collections/' + SOAP_HANDLE + '/products.json?limit=20')
      .then(r => r.json())
      .then(d => { soapIds = (d.products || []).map(p => p.id); });
  }

  function fetchLoofahUI() {
    return fetch('/products/' + LOOFAH_MAIN_HANDLE + '.js')
      .then(r => r.json())
      .then(product => {
        const colorMap = {};
        (product.variants || []).forEach(v => {
          const color = v.option1;
          if (!colorMap[color]) {
            colorMap[color] = v.featured_image
              ? v.featured_image.src
              : (product.images[0] ? product.images[0].src : null);
          }
        });
        return colorMap;
      });
  }

  function fetchGiftVariants() {
    return fetch('/products/' + LOOFAH_GIFT_HANDLE + '.js')
      .then(r => r.json())
      .then(product => {
        const giftMap = {};
        (product.variants || []).forEach(v => {
          if (parseFloat(v.price) === 0) {
            giftMap[v.option1] = v.id;
            freeVariantIds.push(v.id);
          }
        });
        return giftMap;
      });
  }

  function fetchAllData() {
    return Promise.all([fetchSoapIds(), fetchLoofahUI(), fetchGiftVariants()])
      .then(([, colorImgMap, giftMap]) => {
        colorOptions = Object.keys(giftMap).map(color => ({
          name:          color,
          image:         colorImgMap[color] || null,
          giftVariantId: giftMap[color]
        }));
      });
  }

  // ── CART CHECK ────────────────────────────────────

  function checkCart() {
    if (!initialized || isAddingGift) return;
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        let soapCount = 0;
        let giftItem  = null;

        cart.items.forEach(item => {
          if (soapIds.indexOf(item.product_id) !== -1) soapCount += item.quantity;
          if (freeVariantIds.indexOf(item.id) !== -1)  giftItem = item;
        });

        // ── FIX 2: Only reset pickerDismissed when crossing the threshold
        //    FROM below (e.g. 3→4). Going 4→8 never resets it.
        if (soapCount !== prevSoapCount) {
          const wasBelow  = prevSoapCount >= 0 && prevSoapCount < MIN_SOAPS;
          const nowMeets  = soapCount >= MIN_SOAPS;
          if (wasBelow && nowMeets) pickerDismissed = false;
          prevSoapCount = soapCount;
        }

        // ── Safety net: if gift qty > 1 somehow, force back to 1
        if (giftItem && giftItem.quantity > 1) {
          fetch('/cart/change.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ id: giftItem.key, quantity: 1 })
          }).then(() => {
            refreshCartUI();
            if (window.location.pathname === '/cart') {
              setTimeout(() => window.location.reload(), 400);
            }
          });
          return; // skip further logic this tick
        }

        const hasEnough = soapCount >= MIN_SOAPS;

        if (hasEnough && !giftItem && !pickerDismissed) {
          if (!document.getElementById('preesa-gift-picker')) showPicker();
        } else if (!hasEnough && giftItem) {
          hidePicker(false);
          removeGift(giftItem.key).then(() => {
            // FIX: removed duplicate refreshCartUI() call — only needed once
            showToast('Free loofah removed — add 4 soaps to unlock again.', 'remove');
            if (window.location.pathname === '/cart') {
              setTimeout(() => window.location.reload(), 1800);
            } else {
              refreshCartUI();
            }
          });
        } else if (giftItem || !hasEnough) {
          hidePicker(false);
        }

        // UI lock: hide qty selector on the gift's cart row
        if (giftItem) lockGiftQuantityUI();
      });
  }

  // ── LOCK GIFT QTY IN CART UI ─────────────────────
  // FIX 3: Uses confirmed Horizon cart page selectors:
  //   row  → .cart-items__table-row
  //   qty  → .quantity-selector
  // Identified via DevTools console — replaces all previous
  // guesses (.cart-item, quantity-selector-component, etc.)

  function lockGiftQuantityUI() {
    document.querySelectorAll('.cart-items__table-row').forEach(function (row) {
      if (row.classList.contains('preesa-gift-locked')) return;
      if ((row.textContent || '').toLowerCase().indexOf('loofah free gift') === -1) return;

      row.classList.add('preesa-gift-locked');

      var qtyWrapper = row.querySelector('.quantity-selector');
      if (qtyWrapper) {
        qtyWrapper.style.cssText = 'display:none!important';
        if (!row.querySelector('.preesa-gift-qty')) {
          var badge = document.createElement('span');
          badge.className = 'preesa-gift-qty';
          badge.textContent = '1';
          qtyWrapper.parentNode.insertBefore(badge, qtyWrapper);
        }
      }
    });
  }

  // Re-apply lock on cart drawer AJAX re-renders AND cart page AJAX updates
  function observeCart() {
    var debounce;
    var callback = function () {
      clearTimeout(debounce);
      debounce = setTimeout(lockGiftQuantityUI, 60);
    };

    // Cart drawer
    var drawer = document.querySelector('cart-drawer-component, .cart-drawer');
    if (drawer) new MutationObserver(callback).observe(drawer, { childList: true, subtree: true });

    // Cart page — catches Horizon AJAX re-renders of items
    var cartPage = document.querySelector('.cart-items-component, .cart-items__wrapper');
    if (cartPage) new MutationObserver(callback).observe(cartPage, { childList: true, subtree: true });
  }

  // ── ADD / REMOVE GIFT ─────────────────────────────

  function addGift(variantId) {
    isAddingGift = true;
    const btn = document.getElementById('pgpConfirm');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(r => {
      if (!r.ok) throw new Error('Status ' + r.status);
      return r.json();
    })
    .then(() => {
      isAddingGift = false;
      hidePicker(false);
      showToast('🎁 Free loofah added to your cart!', 'add');
      setTimeout(() => {
        if (window.location.pathname === '/cart') {
          window.location.reload();
        } else {
          refreshCartUI();
        }
      }, 1800);
    })
    .catch(err => {
      isAddingGift = false;
      console.warn('[Preesa Gift] Add failed:', err);
      if (btn) { btn.disabled = false; btn.textContent = 'Try again →'; }
    });
  }

  function removeGift(lineKey) {
    return fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  // ── CART UI REFRESH ───────────────────────────────

  function refreshCartUI() {
    fetch('/cart.js').then(r => r.json()).then(function (cart) {
      var count   = cart.item_count || 0;
      var bubble  = document.querySelector('.cart-bubble');
      var countEl = document.querySelector('[data-testid="cart-bubble"]');
      if (bubble && countEl) {
        countEl.textContent = count;
        if (count > 0) {
          bubble.classList.remove('visually-hidden');
          countEl.classList.remove('hidden');
        } else {
          bubble.classList.add('visually-hidden');
          countEl.classList.add('hidden');
        }
      }
      if (window.preesaUpdateCartFab) window.preesaUpdateCartFab(count);
    });
  }

  // ── PICKER UI ────────────────────────────────────

  function showPicker() {
    if (document.getElementById('preesa-gift-picker')) return;
    if (!colorOptions.length) return;

    selectedVariant = null;

    const swatches = colorOptions.map(c => `
      <div class="pgp-swatch" data-variant="${c.giftVariantId}" data-color="${c.name}" data-img="${c.image || ''}">
        ${c.image
          ? `<img src="${c.image}" alt="${c.name}" class="pgp-swatch__img" loading="lazy">`
          : `<div class="pgp-swatch__dot" style="background:${colorHex(c.name)}"></div>`
        }
        <span class="pgp-swatch__label">${c.name}</span>
      </div>
    `).join('');

    const el = document.createElement('div');
    el.id = 'preesa-gift-picker';
    el.innerHTML = `
      <div class="pgp-overlay"></div>
      <div class="pgp-panel">
        <button class="pgp-close" aria-label="Close">✕</button>
        <div class="pgp-emoji">🎁</div>
        <h3 class="pgp-title">You've unlocked a free loofah!</h3>
        <p class="pgp-sub">You've added 4 soaps — pick a color, it's on us.</p>
        <div class="pgp-swatches">${swatches}</div>
        <div class="pgp-preview" id="pgpPreview">
          <img class="pgp-preview__img" id="pgpPreviewImg" src="" alt="">
          <div class="pgp-preview__info">
            <span class="pgp-preview__name" id="pgpPreviewName"></span>
            <span class="pgp-preview__price">₹0.00</span>
          </div>
          <span class="pgp-preview__tag">Free Gift</span>
        </div>
        <button class="pgp-confirm" id="pgpConfirm" disabled>Choose a color above</button>
      </div>
    `;

    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('pgp--visible'));

    el.querySelector('.pgp-close').addEventListener('click', () => hidePicker(true));
    el.querySelector('.pgp-overlay').addEventListener('click', () => hidePicker(true));

    el.querySelectorAll('.pgp-swatch').forEach(swatch => {
      swatch.addEventListener('click', () => {
        el.querySelectorAll('.pgp-swatch').forEach(s => s.classList.remove('pgp-swatch--active'));
        swatch.classList.add('pgp-swatch--active');
        selectedVariant = parseInt(swatch.dataset.variant);

        const preview     = el.querySelector('#pgpPreview');
        const previewImg  = el.querySelector('#pgpPreviewImg');
        const previewName = el.querySelector('#pgpPreviewName');
        const imgEl       = swatch.querySelector('.pgp-swatch__img');

        if (imgEl) { previewImg.src = imgEl.src; previewImg.alt = swatch.dataset.color; }
        previewName.textContent = swatch.dataset.color + ' Loofah Sponge';
        preview.classList.add('pgp-preview--visible');

        const btn = el.querySelector('#pgpConfirm');
        btn.disabled = false;
        btn.textContent = `Add ${swatch.dataset.color} Loofah — Free →`;
      });
    });

    el.querySelector('#pgpConfirm').addEventListener('click', () => {
      if (selectedVariant) addGift(selectedVariant);
    });
  }

  function hidePicker(byUser) {
    if (byUser) pickerDismissed = true;
    const el = document.getElementById('preesa-gift-picker');
    if (!el) return;
    el.classList.remove('pgp--visible');
    setTimeout(() => { if (el.parentNode) el.remove(); }, 300);
  }

  // ── HELPERS ──────────────────────────────────────

  function colorHex(name) {
    const map = {
      Blue: '#4A90D9', Pink: '#F48FB1', Green: '#66BB6A',
      Yellow: '#FDD835', Orange: '#FB8C00', Purple: '#AB47BC'
    };
    return map[name] || '#ccc';
  }

  function showToast(msg, type) {
    const old = document.getElementById('preesa-gift-toast');
    if (old) old.remove();
    const el = document.createElement('div');
    el.id = 'preesa-gift-toast';
    el.className = `pgt pgt--${type}`;
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('pgt--visible'));
    setTimeout(() => {
      el.classList.remove('pgt--visible');
      setTimeout(() => { if (el.parentNode) el.remove(); }, 400);
    }, 3500);
  }

  // ── INIT ─────────────────────────────────────────

  function init() {
    fetchAllData()
      .then(() => {
        initialized = true;
        observeCart();

        // Lock immediately on cart page — don't wait for first poll
        if (window.location.pathname === '/cart') lockGiftQuantityUI();

        setTimeout(() => {
          checkCart();
          setInterval(checkCart, POLL_MS);
        }, 800);
      })
      .catch(e => console.warn('[Preesa Gift]', e));
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();

  /* ─────────────────────────────────────────
    16. BUNDLE OFFER PLACEMENTS
    b) Cart progress bar
    c) Soap product page callout
    d) Soaps collection card badge
    (a) Announcement bar handled in Section 17
  ───────────────────────────────────────── */
  (function () {
    'use strict';

    const SOAP_COLLECTION = 'soaps';
    const MIN_SOAPS       = 4;

    function getSoapIds() {
      return fetch('/collections/' + SOAP_COLLECTION + '/products.json?limit=20')
        .then(r => r.json())
        .then(d => (d.products || []).map(p => p.id));
    }

    /* ── b) CART PROGRESS BAR ── */
    function initCartProgress() {
      if (window.location.pathname !== '/cart') return;

      getSoapIds().then(soapIds => {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            let soapCount = 0;
            cart.items.forEach(item => {
              if (soapIds.indexOf(item.product_id) !== -1) soapCount += item.quantity;
            });

            const remaining = Math.max(0, MIN_SOAPS - soapCount);
            const pct       = Math.min((soapCount / MIN_SOAPS) * 100, 100);
            const unlocked  = soapCount >= MIN_SOAPS;

            const bar = document.createElement('div');
            bar.className = 'preesa-cart-offer' + (unlocked ? ' pco--unlocked' : '');
            bar.innerHTML = `
              <span class="pco-icon">${unlocked ? '🎉' : '🎁'}</span>
              <div class="pco-body">
                <p class="pco-text">
                  ${unlocked
                    ? '<strong>Free loofah unlocked!</strong> Pick your color in the popup.'
                    : `Add <strong>${remaining} more soap${remaining !== 1 ? 's' : ''}</strong> to get a <strong>free loofah</strong>`
                  }
                </p>
                <div class="pco-track"><div class="pco-fill" style="width:${pct}%"></div></div>
                <p class="pco-hint">${soapCount} / ${MIN_SOAPS} soaps added</p>
              </div>
            `;

            function inject() {
              const target = document.querySelector('.cart-items')
                          || document.querySelector('[id*="main-cart-items"]')
                          || document.querySelector('form[action="/cart"]');
              if (target) {
                target.parentNode.insertBefore(bar, target);
              } else {
                setTimeout(inject, 300);
              }
            }
            inject();
          });
      });
    }

    /* ── c) PRODUCT PAGE CALLOUT ── */
    function initProductCallout() {
      if (!document.body.classList.contains('template-product')) return;

      getSoapIds().then(soapIds => {
        const productId = window.ShopifyAnalytics?.meta?.product?.id
          || parseInt(
              document.querySelector('[data-product-id]')?.dataset?.productId
              || document.querySelector('form[action="/cart/add"] [name="id"]')?.value
              || '0'
            );

        if (!soapIds.includes(productId)) return;

        const callout = document.createElement('div');
        callout.className = 'preesa-pdp-offer';
        callout.innerHTML = `
          <span class="ppdo-icon">🎁</span>
          <p class="ppdo-text">Buy <strong>4 soaps</strong> in one order — get a <strong>loofah of your choice free</strong></p>
        `;

        function inject() {
          const btns = document.querySelector('.product-form__buttons')
                    || document.querySelector('.product-form__submit')?.closest('div');
          if (btns) {
            btns.after(callout);
          } else {
            setTimeout(inject, 400);
          }
        }
        inject();
      });
    }

    /* ── d) SOAPS COLLECTION CARD BADGE ── */
    function initCollectionBadge() {
      if (!window.location.pathname.includes('/collections/soaps')) return;

      function addBadges() {
        document.querySelectorAll('.card-wrapper').forEach(card => {
          const wrap = card.querySelector('.card__media') || card.querySelector('.card__inner');
          if (!wrap || wrap.querySelector('.preesa-bundle-badge')) return;
          wrap.style.position = 'relative';
          const badge = document.createElement('span');
          badge.className = 'preesa-bundle-badge';
          badge.textContent = '🎁 Buy 4, get loofah free';
          wrap.appendChild(badge);
        });
      }

      addBadges();
      setTimeout(addBadges, 600);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initCartProgress();
        initProductCallout();
        initCollectionBadge();
      });
    } else {
      initCartProgress();
      initProductCallout();
      initCollectionBadge();
    }

  })();

  /* ─────────────────────────────────────────
     17. ANNOUNCEMENT BAR — Cycling Text
  ───────────────────────────────────────── */
  (function initAnnouncementCycle() {
    const messages = [
      '🌿 100% Natural Ingredients',
      '👌🏻 Handcrafted in India ',
      '🎁 Buy 4 Soaps — Get 1 Loofah Free!',
      '🎉 Launch Offer — 10% OFF above ₹999 · Use code NEW10'
    ];
    const bar = document.querySelector('.announcement-bar__text')
              || document.querySelector('.announcement-bar p');
    if (!bar) return;
    bar.innerHTML = '';
    messages.forEach((msg, i) => {
      const slide = document.createElement('span');
      slide.className = 'preesa-announcement-slide' + (i === 0 ? ' active' : '');
      slide.textContent = msg;
      bar.appendChild(slide);
    });
    const slides = bar.querySelectorAll('.preesa-announcement-slide');
    let current = 0;
    setInterval(() => {
      const currentSlide = slides[current];
      current = (current + 1) % slides.length;
      const nextSlide = slides[current];
      currentSlide.classList.remove('active');
      currentSlide.classList.add('exit');
      setTimeout(() => {
        currentSlide.classList.remove('exit');
        nextSlide.classList.add('active');
      }, 600);
    }, 3000);
  })();


  /* ── Contact Page: Two-column layout ── */
  (function initContactLayout() {
    const contactMain = document.querySelector('#MainContent[data-template="page.contact"]');
    if (!contactMain) return;
    document.body.classList.add('preesa-contact-page');
    if (document.getElementById('preesa-contact-row')) return;
    const leftSection  = contactMain.querySelector('[id$="__main"]');
    const rightSection = contactMain.querySelector('[id$="__form"]');
    if (leftSection && rightSection) {
      const row = document.createElement('div');
      row.id = 'preesa-contact-row';
      contactMain.insertBefore(row, leftSection);
      row.appendChild(leftSection);
      row.appendChild(rightSection);
    } else {
      document.addEventListener('DOMContentLoaded', initContactLayout);
      setTimeout(initContactLayout, 300);
    }
  })();


  /* ─────────────────────────────────────────
     ATC TOAST — Global (.pat-*)
  ───────────────────────────────────────── */
  (function () {
    'use strict';

    function createToast() {
      if (document.getElementById('preesa-atc-toast')) return;
      var el = document.createElement('div');
      el.id = 'preesa-atc-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML =
        '<div class="pat-inner">' +
          '<div class="pat-left">' +
            '<svg class="pat-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="10" cy="10" r="10" fill="#3D6B35"/>' +
              '<path d="M6 10.5L8.5 13L14 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
            '<span class="pat-msg">Item added to cart!</span>' +
          '</div>' +
          '<div class="pat-right">' +
            '<a href="/cart" class="pat-btn">Go to Cart \u2192</a>' +
            '<button class="pat-close" aria-label="Dismiss">\u2715</button>' +
          '</div>' +
        '</div>' +
        '<div class="pat-bar"></div>';
      document.body.appendChild(el);
      el.querySelector('.pat-close').addEventListener('click', hideToast);
    }

    var _timer = null;

    function showToast(title) {
      var toast = document.getElementById('preesa-atc-toast');
      if (!toast) { createToast(); toast = document.getElementById('preesa-atc-toast'); }
      var short = title.length > 32 ? title.slice(0, 30) + '\u2026' : title;
      toast.querySelector('.pat-msg').textContent = short + ' added!';

      var bar = toast.querySelector('.pat-bar');
      bar.style.transition = 'none';
      bar.style.width = '100%';

      toast.classList.add('pat-show');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.style.transition = 'width 5s linear';
          bar.style.width = '0%';
        });
      });

      if (_timer) clearTimeout(_timer);
      _timer = setTimeout(hideToast, 5000);
    }

    function hideToast() {
      var toast = document.getElementById('preesa-atc-toast');
      if (toast) toast.classList.remove('pat-show');
      if (_timer) clearTimeout(_timer);
    }

    /* ── UPDATED: Horizon v3.5.1 cart bubble selectors + FAB ── */
    function updateCartCount(count) {
      var bubble  = document.querySelector('.cart-bubble');
      var countEl = document.querySelector('[data-testid="cart-bubble"]');
      if (bubble && countEl) {
        countEl.textContent = count;
        if (count > 0) {
          bubble.classList.remove('visually-hidden');
          countEl.classList.remove('hidden');
        } else {
          bubble.classList.add('visually-hidden');
          countEl.classList.add('hidden');
        }
      }
      if (window.preesaUpdateCartFab) window.preesaUpdateCartFab(count);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute('action')) return;
      if (form.getAttribute('action').indexOf('/cart/add') === -1) return;

      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var originalHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
        if (item.id) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              showToast(item.title);
            });
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
      });
    });

    document.addEventListener('DOMContentLoaded', createToast);
  })();


  /* ─────────────────────────────────────────
     18. FLOATING CART FAB (.pcf-*)
     Shows bottom-right on all pages when
     cart has 1+ items. Mobile only via CSS.
  ───────────────────────────────────────── */
  (function () {
     /* ── Don't show FAB on cart page ── */
    if (window.location.pathname === '/cart') return;
    /* ── Create FAB element ── */
    var fab = document.createElement('div');
    fab.id = 'preesa-cart-fab';
    fab.innerHTML =
      '<a href="/cart" class="pcf-btn">' +
        '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"' +
            ' d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522' +
            'a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247' +
            ' 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33' +
            ' 0 0 1 1.65-.686">' +
          '</path>' +
        '</svg>' +
        'Cart' +
        '<span class="pcf-count" id="pcf-count">0</span>' +
      '</a>';
    document.body.appendChild(fab);

    /* ── Update FAB count + visibility ── */
    function updateFab(count) {
      var countEl = document.getElementById('pcf-count');
      if (countEl) countEl.textContent = count;
      fab.style.display = count > 0 ? 'block' : 'none';
    }

    /* ── Expose globally so ATC toast + Loofah gift can call it ── */
    window.preesaUpdateCartFab = updateFab;

    /* ── On page load: check if cart already has items (returning visitor) ── */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { updateFab(data.item_count || 0); })
      .catch(function () {});
  })();
    /* ============================================================
    S33 — VIDEO INTRO MODAL
    ============================================================ */
  (function () {
    // Only on homepage
    if (window.location.pathname !== '/') return;

    // ← PASTE YOUR CDN URL HERE after Step 1
    var VIDEO_URL = 'https://cdn.shopify.com/videos/c/o/v/39f2c7b37d9d439a9341bee8e9fab023.mp4';

    var DELAY_MS = 800;

    function buildModal() {
      var modal = document.createElement('div');
      modal.className = 'preesa-video-modal';
      modal.id = 'preesa-video-modal';
      modal.innerHTML =
        '<div class="pvm-backdrop"></div>' +
        '<div class="pvm-container">' +
          '<button class="pvm-close" aria-label="Close video">&#x2715;</button>' +
          '<video class="pvm-video" src="' + VIDEO_URL + '" playsinline preload="auto"></video>' +
          '<div class="pvm-play-overlay">' +
            '<div class="pvm-play-btn">' +
              '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
                '<polygon points="5,3 19,12 5,21"/>' +
              '</svg>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modal);
      return modal;
    }

    function closeModal(modal) {
      modal.classList.remove('pvm-active');
      var video = modal.querySelector('.pvm-video');
      video.pause();
      video.currentTime = 0;
      setTimeout(function () { modal.remove(); }, 400);
    }

    function initModal() {
      var modal = buildModal();
      var video = modal.querySelector('.pvm-video');
      var closeBtn = modal.querySelector('.pvm-close');
      var playOverlay = modal.querySelector('.pvm-play-overlay');

      // Fade in modal
      setTimeout(function () { modal.classList.add('pvm-active'); }, 50);

      // Click play button → video plays WITH audio
      playOverlay.addEventListener('click', function () {
        video.play();
        playOverlay.classList.add('pvm-hidden');
      });

      // Auto-close when video ends
      video.addEventListener('ended', function () { closeModal(modal); });

      // Close button
      closeBtn.addEventListener('click', function () { closeModal(modal); });

      // Tap backdrop to close
      modal.querySelector('.pvm-backdrop').addEventListener('click', function () { closeModal(modal); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(initModal, DELAY_MS);
      });
    } else {
      setTimeout(initModal, DELAY_MS);
    }
  })();

  /* ─────────────────────────────────────────
     CONFIRM LOAD IN CONSOLE (dev only)
  ───────────────────────────────────────── */
  console.log('%c Preesa JS v2 ✅ loaded', 'color: #FFD600; background: #1C1C1E; padding: 4px 10px; border-radius: 4px;');

})(); // ← closes OUTER IIFE